import { render, staticRenderFns } from "./part-comment.vue?vue&type=template&id=07e15fd6&scoped=true&lang=pug"
import script from "./part-comment.vue?vue&type=script&lang=js"
export * from "./part-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e15fd6",
  null
  
)

export default component.exports